var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66797 5.5C6.04868 5.5 7.16797 4.38071 7.16797 3C7.16797 1.61929 6.04868 0.5 4.66797 0.5C3.28726 0.5 2.16797 1.61929 2.16797 3C2.16797 4.38071 3.28726 5.5 4.66797 5.5ZM4.66797 4.5C5.4964 4.5 6.16797 3.82843 6.16797 3C6.16797 2.17157 5.4964 1.5 4.66797 1.5C3.83954 1.5 3.16797 2.17157 3.16797 3C3.16797 3.82843 3.83954 4.5 4.66797 4.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.832 3C13.832 4.38071 12.7128 5.5 11.332 5.5C9.9513 5.5 8.83203 4.38071 8.83203 3C8.83203 1.61929 9.9513 0.5 11.332 0.5C12.7128 0.5 13.832 1.61929 13.832 3ZM12.832 3C12.832 3.82843 12.1604 4.5 11.332 4.5C10.5036 4.5 9.83203 3.82843 9.83203 3C9.83203 2.17157 10.5036 1.5 11.332 1.5C12.1604 1.5 12.832 2.17157 12.832 3Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.74808 7.7654C10.2434 7.5936 10.7762 7.5 11.3325 7.5C12.7809 7.5 14.0796 8.13587 14.967 9.147C14.972 9.1528 14.9992 9.1902 14.9992 9.27787V10.5C14.9992 10.6841 14.8499 10.8333 14.6658 10.8333H10.3089C10.2562 11.2013 10.1177 11.5417 9.91428 11.8333H14.6658C15.4022 11.8333 15.9992 11.2364 15.9992 10.5V9.27787C15.9992 8.98893 15.9091 8.70453 15.7186 8.4874C14.6494 7.26907 13.0808 6.5 11.3325 6.5C10.5042 6.5 9.71615 6.67267 9.00249 6.98393C8.98435 6.9918 8.96662 7.0002 8.94922 7.00893C9.23549 7.23947 9.50269 7.49253 9.74808 7.7654Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 11.8333C8.31533 11.8333 8.60507 11.7239 8.83333 11.5409C9.13813 11.2965 9.33333 10.9211 9.33333 10.5V9.27787C9.33333 8.98893 9.24327 8.70453 9.05273 8.4874C8.8406 8.24567 8.60873 8.0216 8.3598 7.81773C7.354 6.99413 6.06803 6.5 4.66667 6.5C2.91839 6.5 1.34974 7.26907 0.280605 8.4874C0.090064 8.70453 0 8.98893 0 9.27787V10.5C0 11.2364 0.596954 11.8333 1.33333 11.8333H8ZM8.30113 9.147C8.3062 9.1528 8.33333 9.1902 8.33333 9.27787V10.5C8.33333 10.6841 8.18407 10.8333 8 10.8333H1.33333C1.14924 10.8333 1 10.6841 1 10.5V9.27787C1 9.1902 1.02716 9.1528 1.03223 9.147C1.91956 8.13587 3.21825 7.5 4.66667 7.5C6.11508 7.5 7.4138 8.13587 8.30113 9.147Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.c4e89ca402dd6536ac970f0880ca227e.svg";
export { ForwardRef as ReactComponent };